<template>
<svg x="0px" y="0px" viewBox="0 0 142 200" class="pin-origami">
    <g transform="translate(-15.000000, -202.000000)">
        <path :style="`fill:${color}`" d="M85.92,202c39.17,0,70.92,31.85,70.92,71.13s-42.34,90.78-67.22,126.87
            c-1.59,2.65-5.29,2.65-7.41,0C57.87,363.91,15,312.42,15,273.13S46.76,202,85.92,202z M86.37,240.3
            c18.6,0,33.59,14.99,33.59,33.07c0,18.6-14.99,33.59-33.59,33.59c-18.09,0-33.07-14.99-33.07-33.59
            C53.3,255.28,68.28,240.3,86.37,240.3z"/>
    </g>
</svg>

</template>

<script>
export default {
    name: 'pin-origami',
    props: ['color']
}
</script>

<style lang="scss" scoped>
	path{
        fill-rule:evenodd;
        clip-rule:evenodd;
    }
</style>